// import { useState, useEffect } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import HospitalInquiryModal from "@/components/HospitalInquiryModal";
// import { MapPin, BedDouble, Award, ArrowRight, CheckCircle } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// // const HOSPITAL_IMG = "https://images.pexels.com/photos/18470744/pexels-photo-18470744.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

// export default function HospitalsPage() {
//   const [hospitals, setHospitals] = useState([]);

//   useEffect(() => {
//     axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
//   }, []);

//   return (
//     <div data-testid="hospitals-page">
//       <section className="bg-gradient-to-b from-orange-50 to-white py-16 md:py-24">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Trusted Network</Badge>
//           <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4" data-testid="hospitals-title">Our Partner Hospitals</h1>
//           <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">We partner with India's top accredited hospitals to ensure world-class medical care for our international patients.</p>
//         </div>
//       </section>

//       <section className="py-12 md:py-20">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {hospitals.map((h) => (
//               <Card key={h.id} className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] overflow-hidden card-hover" data-testid={`hospital-detail-${h.id}`}>
//                 <div className="h-40 relative">
//                   <img src={h.logo_url } alt={h.name} className="w-full h-full object-cover" />
//                   <div className="absolute top-3 right-3">
//                     <Badge className="bg-white/90 text-orange-600 border-0 shadow-md font-semibold text-xs">{h.accreditation}</Badge>
//                   </div>
//                 </div>
//                 <div className="p-4">
//                   <h2 className="font-heading text-base font-semibold text-slate-900 mb-1 line-clamp-1">{h.name}</h2>
//                   <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
//                     <span className="flex items-center gap-1"><MapPin className="h-3 w-3" /> {h.city}</span>
//                     <span className="flex items-center gap-1"><BedDouble className="h-3 w-3" /> {h.beds}</span>
//                   </div>
//                   <p className="text-slate-600 text-xs leading-relaxed mb-3 line-clamp-2">{h.description}</p>
//                   <div className="flex flex-wrap gap-1 mb-4">
//                     {h.specialties.slice(0, 3).map((s) => (
//                       <Badge key={s} variant="outline" className="text-[10px] border-slate-200 text-slate-600 px-1.5 py-0">{s}</Badge>
//                     ))}
//                     {h.specialties.length > 3 && <Badge variant="outline" className="text-[10px] border-slate-200 text-slate-500 px-1.5 py-0">+{h.specialties.length - 3}</Badge>}
//                   </div>
//                   <HospitalInquiryModal
//                     hospitalName={h.name}
//                     treatments={h.specialties}
//                     trigger={
//                       <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-4 py-2 h-auto font-semibold w-full text-xs" data-testid={`hospital-inquiry-${h.id}`}>
//                         Inquire Now <ArrowRight className="ml-1 h-3 w-3" />
//                       </Button>
//                     }
//                   />
//                 </div>
//               </Card>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="bg-[#F8FAFC] py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-10">
//             <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">Why Our Hospital Network?</h2>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {[
//               { icon: Award, title: "Accredited Facilities", desc: "All hospitals are NABH/JCI accredited with international quality standards." },
//               { icon: CheckCircle, title: "Experienced Specialists", desc: "Access to 500+ specialists across all medical disciplines." },
//               { icon: MapPin, title: "Pan-India Coverage", desc: "Hospitals in Mumbai, Delhi, Gurugram, Chennai, and more cities." },
//             ].map((f, i) => (
//               <div key={i} className="flex gap-4 items-start" data-testid={`hospital-feature-${i}`}>
//                 <div className="w-10 h-10 rounded-lg bg-orange-600/10 flex items-center justify-center shrink-0">
//                   <f.icon className="h-5 w-5 text-orange-600" />
//                 </div>
//                 <div>
//                   <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{f.title}</h3>
//                   <p className="text-slate-500 text-sm leading-relaxed">{f.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }




// import { useState, useEffect, useMemo } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import HospitalInquiryModal from "@/components/HospitalInquiryModal";
// import { MapPin, BedDouble, Award, ArrowRight, CheckCircle, Search, X } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// export default function HospitalsPage() {
//   const [hospitals, setHospitals] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
//   }, []);

//   // ── Filter hospitals based on search query ──
//   const filteredHospitals = useMemo(() => {
//     if (!searchQuery.trim()) return hospitals;
//     const q = searchQuery.toLowerCase().trim();
//     return hospitals.filter(h =>
//       h.name?.toLowerCase().includes(q) ||
//       h.city?.toLowerCase().includes(q) ||
//       h.description?.toLowerCase().includes(q) ||
//       h.specialties?.some(s => s.toLowerCase().includes(q))
//     );
//   }, [hospitals, searchQuery]);

//   return (
//     <div data-testid="hospitals-page">
//       <section className="bg-gradient-to-b from-orange-50 to-white py-5 md:py-10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">Trusted Network</Badge>
//           <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4" data-testid="hospitals-title">Our Partner Hospitals</h1>
//           <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">We partner with India's top accredited hospitals to ensure world-class medical care for our international patients.</p>
//         </div>
//       </section>

//       <section className="py-5 md:py-5">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

//           {/* ── Search Bar ── */}
//           <div className="max-w-xl mx-auto mb-10">
//             <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200">
//               <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
//               <input
//                 type="text"
//                 placeholder="Search hospitals by name, city, specialty..."
//                 value={searchQuery}
//                 onChange={e => setSearchQuery(e.target.value)}
//                 className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
//                 data-testid="hospital-search-input"
//               />
//               {searchQuery && (
//                 <button
//                   onClick={() => setSearchQuery("")}
//                   className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
//                   data-testid="hospital-search-clear"
//                 >
//                   <X className="h-4 w-4" />
//                 </button>
//               )}
//             </div>

//             {/* Live Result Count */}
//             {searchQuery.trim() && (
//               <p className="text-xs text-slate-400 mt-2 text-center" data-testid="hospital-search-count">
//                 {filteredHospitals.length > 0 ? (
//                   <span>
//                     Showing{" "}
//                     <span className="text-orange-500 font-semibold">{filteredHospitals.length}</span>
//                     {" "}hospital{filteredHospitals.length !== 1 ? "s" : ""} for "
//                     <span className="text-slate-600 font-medium">{searchQuery}</span>"
//                   </span>
//                 ) : (
//                   <span>
//                     No hospitals found for "
//                     <span className="text-slate-600 font-medium">{searchQuery}</span>"
//                   </span>
//                 )}
//               </p>
//             )}
//           </div>

//           {/* Cards Grid or Empty State */}
//           {filteredHospitals.length > 0 ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//               {filteredHospitals.map((h) => (
//                 <Card key={h.id} className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] overflow-hidden card-hover" data-testid={`hospital-detail-${h.id}`}>
//                   <div className="h-40 relative">
//                     <img src={h.logo_url} alt={h.name} className="w-full h-full object-cover" />
//                     <div className="absolute top-3 right-3">
//                       <Badge className="bg-white/90 text-orange-600 border-0 shadow-md font-semibold text-xs">{h.accreditation}</Badge>
//                     </div>
//                   </div>
//                   <div className="p-4">
//                     <h2 className="font-heading text-base font-semibold text-slate-900 mb-1 line-clamp-1">{h.name}</h2>
//                     <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
//                       <span className="flex items-center gap-1"><MapPin className="h-3 w-3" /> {h.city}</span>
//                       <span className="flex items-center gap-1"><BedDouble className="h-3 w-3" /> {h.beds}</span>
//                     </div>
//                     <p className="text-slate-600 text-xs leading-relaxed mb-3 line-clamp-2">{h.description}</p>
//                     <div className="flex flex-wrap gap-1 mb-4">
//                       {h.specialties.slice(0, 3).map((s) => (
//                         <Badge key={s} variant="outline" className="text-[10px] border-slate-200 text-slate-600 px-1.5 py-0">{s}</Badge>
//                       ))}
//                       {h.specialties.length > 3 && <Badge variant="outline" className="text-[10px] border-slate-200 text-slate-500 px-1.5 py-0">+{h.specialties.length - 3}</Badge>}
//                     </div>
//                     <HospitalInquiryModal
//                       hospitalName={h.name}
//                       treatments={h.specialties}
//                       trigger={
//                         <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-4 py-2 h-auto font-semibold w-full text-xs" data-testid={`hospital-inquiry-${h.id}`}>
//                           Inquire Now <ArrowRight className="ml-1 h-3 w-3" />
//                         </Button>
//                       }
//                     />
//                   </div>
//                 </Card>
//               ))}
//             </div>
//           ) : (
//             /* ── Empty State ── */
//             <div className="flex flex-col items-center justify-center py-24 text-center">
//               <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
//                 <Search className="h-9 w-9 text-orange-300" />
//               </div>
//               <h3 className="text-xl font-semibold text-slate-700 mb-2">No hospitals found</h3>
//               <p className="text-slate-400 text-sm max-w-sm mb-6">
//                 We couldn't find any hospitals matching "
//                 <span className="text-orange-500 font-medium">{searchQuery}</span>
//                 ". Try a different keyword.
//               </p>
//               <Button
//                 onClick={() => setSearchQuery("")}
//                 className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
//               >
//                 Clear Search
//               </Button>
//             </div>
//           )}

//         </div>
//       </section>

//       <section className="bg-[#F8FAFC] py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-10">
//             <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">Why Our Hospital Network?</h2>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {[
//               { icon: Award, title: "Accredited Facilities", desc: "All hospitals are NABH/JCI accredited with international quality standards." },
//               { icon: CheckCircle, title: "Experienced Specialists", desc: "Access to 500+ specialists across all medical disciplines." },
//               { icon: MapPin, title: "Pan-India Coverage", desc: "Hospitals in Mumbai, Delhi, Gurugram, Chennai, and more cities." },
//             ].map((f, i) => (
//               <div key={i} className="flex gap-4 items-start" data-testid={`hospital-feature-${i}`}>
//                 <div className="w-10 h-10 rounded-lg bg-orange-600/10 flex items-center justify-center shrink-0">
//                   <f.icon className="h-5 w-5 text-orange-600" />
//                 </div>
//                 <div>
//                   <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{f.title}</h3>
//                   <p className="text-slate-500 text-sm leading-relaxed">{f.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// HospitalsPage.jsx
import { useState, useEffect, useMemo } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import HospitalInquiryModal from "@/components/HospitalInquiryModal";
import { MapPin, BedDouble, Award, ArrowRight, CheckCircle, Search, X } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HospitalsPage() {
  const [hospitals, setHospitals] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios.get(`${API}/hospitals`).then(r => setHospitals(r.data)).catch(console.error);
  }, []);

  const filteredHospitals = useMemo(() => {
    if (!searchQuery.trim()) return hospitals;
    const q = searchQuery.toLowerCase().trim();
    return hospitals.filter(h =>
      h.name?.toLowerCase().includes(q) ||
      h.city?.toLowerCase().includes(q) ||
      h.description?.toLowerCase().includes(q) ||
      h.specialties?.some(s => s.toLowerCase().includes(q))
    );
  }, [hospitals, searchQuery]);

  return (
    <div data-testid="hospitals-page">

      {/* ── Hero + Search Section ── */}
      <section className="bg-gradient-to-b from-orange-50 to-white py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Heading */}
          <div className="text-center mb-10">
            <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
              Trusted Network
            </Badge>
            <h1
              className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4"
              data-testid="hospitals-title"
            >
              Our Partner <span className="text-orange-600">Hospitals</span>
            </h1>
            <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">
              We partner with India's top accredited hospitals to ensure world-class medical care for our international patients.
            </p>
          </div>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200">
              <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
              <input
                type="text"
                placeholder="Search hospitals by name, city, specialty..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
                data-testid="hospital-search-input"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
                  data-testid="hospital-search-clear"
                >
                  <X className="h-4 w-4" />
                </button>
              )}
            </div>

            {/* Live Result Count */}
            {searchQuery.trim() && (
              <p className="text-xs text-slate-400 mt-2 text-center" data-testid="hospital-search-count">
                {filteredHospitals.length > 0 ? (
                  <span>
                    Showing{" "}
                    <span className="text-orange-500 font-semibold">{filteredHospitals.length}</span>
                    {" "}hospital{filteredHospitals.length !== 1 ? "s" : ""} for "
                    <span className="text-slate-600 font-medium">{searchQuery}</span>"
                  </span>
                ) : (
                  <span>
                    No hospitals found for "
                    <span className="text-slate-600 font-medium">{searchQuery}</span>"
                  </span>
                )}
              </p>
            )}
          </div>

        </div>
      </section>

      {/* ── Hospitals Grid ── */}
      <section className="py-10 md:py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredHospitals.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {filteredHospitals.map((h) => (
                <Card
                  key={h.id}
                  className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.05)] overflow-hidden card-hover"
                  data-testid={`hospital-detail-${h.id}`}
                >
                  <div className="h-40 relative">
                    <img src={h.logo_url} alt={h.name} className="w-full h-full object-cover" />
                    <div className="absolute top-3 right-3">
                      <Badge className="bg-white/90 text-orange-600 border-0 shadow-md font-semibold text-xs">
                        {h.accreditation}
                      </Badge>
                    </div>
                  </div>
                  <div className="p-4">
                    <h2 className="font-heading text-base font-semibold text-slate-900 mb-1 line-clamp-1">{h.name}</h2>
                    <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
                      <span className="flex items-center gap-1"><MapPin className="h-3 w-3" /> {h.city}</span>
                      <span className="flex items-center gap-1"><BedDouble className="h-3 w-3" /> {h.beds}</span>
                    </div>
                    <p className="text-slate-600 text-xs leading-relaxed mb-3 line-clamp-2">{h.description}</p>
                    <div className="flex flex-wrap gap-1 mb-4">
                      {h.specialties.slice(0, 3).map((s) => (
                        <Badge key={s} variant="outline" className="text-[10px] border-slate-200 text-slate-600 px-1.5 py-0">{s}</Badge>
                      ))}
                      {h.specialties.length > 3 && (
                        <Badge variant="outline" className="text-[10px] border-slate-200 text-slate-500 px-1.5 py-0">
                          +{h.specialties.length - 3}
                        </Badge>
                      )}
                    </div>
                    <HospitalInquiryModal
                      hospitalName={h.name}
                      treatments={h.specialties}
                      trigger={
                        <Button
                          className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-4 py-2 h-auto font-semibold w-full text-xs"
                          data-testid={`hospital-inquiry-${h.id}`}
                        >
                          Inquire Now <ArrowRight className="ml-1 h-3 w-3" />
                        </Button>
                      }
                    />
                  </div>
                </Card>
              ))}
            </div>
          ) : (
            /* ── Empty State ── */
            <div className="flex flex-col items-center justify-center py-24 text-center">
              <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
                <Search className="h-9 w-9 text-orange-300" />
              </div>
              <h3 className="text-xl font-semibold text-slate-700 mb-2">No hospitals found</h3>
              <p className="text-slate-400 text-sm max-w-sm mb-6">
                We couldn't find any hospitals matching "
                <span className="text-orange-500 font-medium">{searchQuery}</span>
                ". Try a different keyword.
              </p>
              <Button
                onClick={() => setSearchQuery("")}
                className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
              >
                Clear Search
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* ── Why Our Network ── */}
      <section className="bg-[#F8FAFC] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-4">
              Why Our Hospital Network?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: Award,
                title: "Accredited Facilities",
                desc: "All hospitals are NABH/JCI accredited with international quality standards."
              },
              {
                icon: CheckCircle,
                title: "Experienced Specialists",
                desc: "Access to 500+ specialists across all medical disciplines."
              },
              {
                icon: MapPin,
                title: "Pan-India Coverage",
                desc: "Hospitals in Mumbai, Delhi, Gurugram, Chennai, and more cities."
              },
            ].map((f, i) => (
              <div key={i} className="flex gap-4 items-start" data-testid={`hospital-feature-${i}`}>
                <div className="w-10 h-10 rounded-lg bg-orange-600/10 flex items-center justify-center shrink-0">
                  <f.icon className="h-5 w-5 text-orange-600" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{f.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}